var _path, _circle, _circle2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgAuditor(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 17,
    height: 17,
    viewBox: "0 0 17 17",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M8.42114 0C3.77772 0 0 3.77772 0 8.42114C0 13.0646 3.77772 16.8423 8.42114 16.8423C13.0646 16.8423 16.8423 13.0646 16.8423 8.42114C16.8423 3.77772 13.0646 0 8.42114 0ZM8.42114 1.68423C11.1269 1.68423 13.4587 3.29098 14.5298 5.59838C14.2697 5.47525 14.0179 5.33516 13.7761 5.179C13.4317 4.96174 13.041 4.715 12.5467 4.52889C11.9833 4.31415 11.3677 4.21057 10.6654 4.21057C9.96305 4.21057 9.34747 4.31415 8.78409 4.52805C8.28977 4.71584 7.89903 4.96258 7.5445 5.18574C7.22618 5.38532 6.95249 5.5588 6.61565 5.68596C6.24007 5.82827 5.83248 5.8948 5.33058 5.8948C4.82952 5.8948 4.42194 5.82827 4.0472 5.68596C3.71036 5.5588 3.43414 5.38448 3.11582 5.18237C2.98024 5.09732 2.8295 5.00721 2.67792 4.91879C3.86278 2.98277 5.98996 1.68423 8.42114 1.68423ZM8.42114 15.1581C4.70658 15.1581 1.68423 12.1357 1.68423 8.42114C1.68423 7.73903 1.78781 7.08218 1.97728 6.46154C2.05644 6.51038 2.13308 6.55418 2.2156 6.60723C2.56171 6.82618 2.95329 7.07376 3.45014 7.26071C4.01352 7.47545 4.62826 7.57903 5.33058 7.57903C6.03206 7.57903 6.64765 7.47545 7.21271 7.26155C7.70703 7.07376 8.09777 6.82702 8.4523 6.60386C8.77062 6.40428 9.04431 6.2308 9.38115 6.1028C9.75589 5.96133 10.1635 5.8948 10.6654 5.8948C11.1673 5.8948 11.5749 5.96133 11.9496 6.10365C12.2856 6.22996 12.5601 6.40344 12.8877 6.6106C13.2321 6.82786 13.6229 7.0746 14.1172 7.26155C14.4229 7.37776 14.7471 7.4544 15.0882 7.50661C15.1294 7.80724 15.1581 8.1104 15.1581 8.42114C15.1581 12.1357 12.1357 15.1581 8.42114 15.1581Z",
    fill: "#2E2E36"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 5.5,
    cy: 9.5,
    r: 1.5,
    fill: "#2E2E36"
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    cx: 11.5,
    cy: 9.5,
    r: 1.5,
    fill: "#2E2E36"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAuditor);
export default __webpack_public_path__ + "static/media/auditor.3ceef97f339c12ff30401e6df7ffc726.svg";
export { ForwardRef as ReactComponent };